import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';  // Import DOMPurify untuk sanitasi
import './PostDetail.css';

const PostDetail = () => {
  const { url } = useParams(); // Mengambil URL dari parameter
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null); // Menyimpan error jika terjadi kesalahan
  const [isLoading, setIsLoading] = useState(true); // Menambahkan status loading

  useEffect(() => {
    setIsLoading(true); // Set loading ke true setiap kali URL berubah
    // Panggil API untuk mendapatkan artikel berdasarkan URL
    if (window.self !== window.top) {
      window.top.location = window.self.location;
    }

    axios
      .get(`https://infoupiyptk.com/webupiyptk/api/post/getpost.php?url=${url}`)
      .then(response => {
        if (response.status === 200) {
          setPost(response.data);
        } else {
          setError('Post not found');
        }
      })
      .catch(error => {
        setError('There was an error fetching the post!');
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false); // Set loading ke false setelah fetch selesai
      });
  }, [url]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  // Format tanggal menjadi 26 November 2024
  const formattedDate = new Date(post.created_at).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  // Sanitasi HTML untuk mencegah XSS, mengizinkan tag <br>
  const sanitizedBody = DOMPurify.sanitize(post.body, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'], // Menambahkan <br> ke dalam daftar tag yang diizinkan
    ALLOWED_ATTR: ['href', 'target'], // Menambahkan atribut yang diizinkan untuk tag <a>
  });

  return (
    <div className="post-detail">
      <div className="breadcrumb">
        <a href="/">Home </a>
        <span style={{ fontSize: '13px', margin: '0px 5px', color: '#FFD62C' }}> / </span>
        <span style={{ fontSize: '13px' }}> {post.categories}</span>
      </div>

      <h1 className="post-title-detail" style={{ textAlign: 'start' }}>{post.title}</h1>

      <div className="post-meta">
        {formattedDate} - {post.categories}
      </div>

      <div className="post-featured-image-container">
        <img
          src={post.featured_image ? `https://infoupiyptk.com/webupiyptk/api/post/uploads/${post.featured_image}` : 'sample-post-image.jpg'}
          onError={(e) => { e.target.src = 'https://infoupiyptk.com/webupiyptk/api/post/uploads/sample-post-image.jpg'; e.target.onerror = null; }}
          alt={post.title}
          className="post-featured-image"
        />
      </div>

      {/* Post Body - Sanitized */}
      <div
        className="post-body"
        dangerouslySetInnerHTML={{ __html: sanitizedBody }} // Menampilkan konten HTML yang sudah disanitasi
      />

      <div className="post-tags">
        <span style={{ marginRight: '10px', fontWeight: 'bold' }}>Tags:</span>
        {post.tags.split(' ').map((tag, index) => (
          <span key={index}>{tag}</span>
        ))}
      </div>
    </div>
  );
};

export default PostDetail;
